export enum SelectedTabsIds {
    SDL = 'SDL',
    DF1 = 'DF1',
    DF2 = 'DF2',
    EMIR = 'EMIR',
    CCCL = 'CCCL'
}
